import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { InvestmentDecreaseReaction } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: InvestmentDecreaseReaction & { riskProfil: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<
      InvestmentDecreaseReaction & { riskProfil: any }
    > = {
      ownerId: [entity.ownerId],
      userFirstName: [entity.userFirstName],
      userLastName: [entity.userLastName],

      riskProfil: this.formBuilder.group({
        hadInvestmentDecrease: [
          entity?.riskProfil?.hadInvestmentDecrease || false,
          Validators.required,
        ],
        investmentDecreaseReaction: [
          entity?.riskProfil?.investmentDecreaseReaction || null,
          Validators.required,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: InvestmentDecreaseReaction[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  extract() {
    return this.form.value.owners;
  }
}
